import { render, staticRenderFns } from "./Posts.vue?vue&type=template&id=6553aff2&scoped=true"
import script from "./Posts.vue?vue&type=script&lang=js"
export * from "./Posts.vue?vue&type=script&lang=js"
import style0 from "./Posts.vue?vue&type=style&index=0&id=6553aff2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6553aff2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6553aff2')) {
      api.createRecord('6553aff2', component.options)
    } else {
      api.reload('6553aff2', component.options)
    }
    module.hot.accept("./Posts.vue?vue&type=template&id=6553aff2&scoped=true", function () {
      api.rerender('6553aff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/overlay/Posts.vue"
export default component.exports